import React from "react";
import styled from "styled-components";
import { HomeContent } from "../../../../hooks/api/queries/useHome";
import { breakpoint } from "../../../../styles/constants";
import { WImage } from "../../../ui/image/Image";
import { Link } from "react-router-dom";
import { appendCommitHash } from "../../../../utils/appendHash";
import { IMAGE_RATIOS } from "../../../../styles/imageRatios";

interface Props {
  item: HomeContent;
}

export const HomePromos = ({ item }: Props) => {
  const promos = item?.promos?.filter(
    (el) => el.localizedImage?.path || el.imageDefault?.path
  );

  if ((promos?.length ?? 0) === 0) return null;

  return (
    <Wrapper>
      {promos?.map((el, index) => (
        <React.Fragment key={`footer-img-${index}`}>
          <Container $sorting={el.sorting}>
            {el.destinationUrl || el.defaultDestinationUrl ? (
              <Link
                to={appendCommitHash(el?.destinationUrl ?? "")}
                key={el?.localizedImage?.id ?? el?.imageDefault?.id}
              >
                <WImage
                  image={
                    el.localizedImage?.path
                      ? el.localizedImage
                      : el.imageDefault
                  }
                />
              </Link>
            ) : (
              <WImage
                image={
                  el.localizedImage?.path ? el.localizedImage : el.imageDefault
                }
              />
            )}
          </Container>
        </React.Fragment>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  @media (min-width: ${breakpoint}) {
    flex-direction: row;
  }
  gap: 1.25rem;
  margin-bottom: 60px;
`;

const Container = styled.div<{ $sorting?: number }>`
  img {
    aspect-ratio: ${IMAGE_RATIOS.HOME_PROMO_MOBILE};
    object-fit: cover;
  }

  @media (min-width: ${breakpoint}) {
    flex: 1;
    min-width: ${({ $sorting }) =>
      $sorting === 3 ? "100%" : "calc((100% - 1.25rem) / 2)"};

    img {
      aspect-ratio: ${({ $sorting }) =>
        $sorting === 3
          ? IMAGE_RATIOS.HOME_PROMO_FOOTER_LARGE
          : IMAGE_RATIOS.HOME_PROMO_FOOTER_THIN};
    }
  }
`;
